import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const justifiInlineStyles = css`
  :root {
    --jfi-primary-color: ${theme.colors.primary50};
    --jfi-layout-font-family: ${theme.font.family};
    --jfi-form-label-font-family: ${theme.font.family};
    --jfi-error-message-color: ${theme.colors.critical50};
  }

  ::part(font-family) {
    font-family: ${theme.font.family};
  }

  ::part(color) {
    color: ${theme.colors.neutral50};
  }

  ::part(background-color) {
    background-color: transparent;
  }

  ::part(button) {
    padding: ${theme.spacing(1)} ${theme.spacing(1.5)};
    border-radius: ${theme.borderRadius.small};
    border: none;
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.large};
  }

  ::part(button-primary) {
    color: ${theme.colors.white};
  }

  ::part(button-primary):hover {
    background-color: ${theme.colors.primary70};
  }

  ::part(input) {
    position: relative;
    z-index: 1;
    padding: ${theme.spacing(1)} ${theme.spacing(2)};
    border-radius: ${theme.borderRadius.small};
    font-size: ${theme.font.size.large};
    color: ${theme.colors.neutral90};
    border: solid 1px ${theme.colors.neutral30};
  }

  ::part(input-focused) {
    border: solid 1px ${theme.colors.primary50};
    box-shadow: none;
  }

  ::part(input-invalid) {
    border-color: #8a2a35;
    box-shadow: 0 0 0 0.25rem rgba(244, 67, 54, 0.25rem);
  }

  ::part(input-invalid-and-focused) {
    box-shadow: 0 0 0 0.25rem rgba(244, 67, 54, 0.25rem);
    border-color: #8a2a35;
  }

  ::part(label) {
    margin: 0;
    position: relative;
    color: ${theme.colors.neutral50};
    z-index: 2;
    background-color: ${theme.colors.white};
    width: fit-content;
    padding: 0 ${theme.spacing(0.5)};
    font-size: ${theme.font.size.large};
  }

  ::part(input-radio) {
    background-color: #fff;
    border-color: #333;
  }

  ::part(input-radio-checked) {
    background-color: #000;
    border-color: ${theme.colors.primary90};
  }

  ::part(input-radio-checked-focused) {
    background-color: #000;
    border-color: ${theme.colors.primary90};
  }

  ::part(input-checkbox) {
    border-color: #333;
  }

  ::part(input-checkbox-checked) {
    background-color: #000;
    border-color: #333;
  }

  ::part(input-checkbox-checked-focused) {
    background-color: #000;
    box-shadow: 0 0 0 0.25rem rgba(0, 0, 0, 0.25);
  }

  ::part(input-checkbox-focused) {
    background-color: #fff;
    box-shadow: 0 0 0 0.25rem rgba(0, 0, 0, 0.25);
  }

  ::part(radio-list-item) {
    border-bottom: 1px solid #ddd;
  }

  ::part(radio-list-item):hover {
    background-color: #f9f9f9;
    cursor: pointer;
  }

  ::part(input-hidden) {
    display: none;
  }
  ::part(hidden) {
    display: none;
  }
  ::part(hidden-input) {
    display: none;
  }

  ::part(button-secondary) {
    background-color: ${theme.colors.white};
    color: ${theme.colors.neutral70};
    border: solid 1px ${theme.colors.neutral30};
  }

  ::part(button-secondary-hover),
  ::part(button-secondary-focus) {
    background-color: ${theme.colors.neutral10};
    color: ${theme.colors.neutral90};
    border-color: ${theme.colors.neutral90};
  }

  ::part(button-secondary-disabled) {
    color: ${theme.colors.neutral70};
    background-color: ${theme.colors.neutral10};
  }
`;

export const justifiOverrideStyles = css`
  h1 {
    font-size: ${theme.font.size.h2};
    font-weight: ${theme.font.weight.bold};
    color: ${theme.colors.neutral90};
    font-family: ${theme.font.family};
    margin-bottom: 0;
  }

  form-control-date {
    display: flex;
    flex-direction: column;
  }

  .form-group .d-flex:has(label):has(+ .is-invalid),
  .form-group label:has(+ .is-invalid) {
    color: ${theme.colors.critical50} !important;
  }

  .form-group .d-flex:has(label),
  .form-group label:has(+ input) {
    margin-bottom: 4px;
  }

  [part='billing-form'] .header-3 {
    margin-bottom: ${theme.spacing(1)} !important;
  }
`;
